<template>
    <div class="ado-admin__dashboard">
        <div class="ado-admin__header">
            <h5 class="ado-admin__header-title">Dashboard</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <div class="row">
                <div class="col-12">
                    <status :status="status"></status>
                </div>
                <div class="col-lg-6">
                    <queue :data="queueData" :message="queueMessage" :result="queueResult" @refreshQueue="refreshQueue"
                        :counsellorsData="counsellorsData" :counsellorsResult="counsellorsResult"
                        :waitingAreasData="waitingAreasData">
                    </queue>
                </div>
                <div class="col-lg-6">
                    <dequeue :data="dequeueData" :message="dequeueMessage" :result="dequeueResult"
                        @refreshQueue="refreshQueue" :counsellorsData="counsellorsData"
                        :counsellorsResult="counsellorsResult">
                    </dequeue>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dequeue from '../../components/DeQueue/DeQueue';
import Status from '../../components/Status/Status.vue';
import Queue from '../../components/Queue/Queue';

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'ado-admin-dashboard',
    components: {
        Dequeue,
        Status,
        Queue
    },
    data() {
        return {
            counsellorsData: [],
            counsellorsResult: '',
            dataRefresh: '',
            dequeueData: [],
            dequeueMessage: '',
            dequeueResult: '',
            queueData: [],
            queueMessage: '',
            queueResult: '',
            status: {

            },
            waitingAreasData: []
        }
    },
    methods: {
        getCounsellors() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorsData&department=${DEPARTMENT}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Store counsellors
                    if (json.result.match(/^OK/i)) {
                        that.counsellorsData = json.data || that.counsellorsData;
                        that.waitingAreasData = json.waitingAreas || that.waitingAreasData;
                    } else {
                        that.counsellorsResult = 'ERROR';
                    }
                })
                .catch(function (error) {
                    that.counsellorsResult = 'ERROR';
                })
        },
        getDequeue() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getQueue&type=dequeued&department=${DEPARTMENT}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Set data
                    that.dequeueData = json.data || [];
                    that.dequeueMessage = json.message;
                    that.dequeueResult = json.result;
                })
                .catch(function (error) {
                    // Set error result
                    that.dequeueResult = 'error';
                })
        },
        getQueue() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getQueue&department=${DEPARTMENT}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    console.log(json);
                    // Set data
                    that.queueData = json.data || [];
                    that.queueMessage = json.message;
                    that.queueResult = json.result;
                    that.status = json.status || {};
                })
                .catch(function (error) {
                    // Set error result
                    that.queueResult = 'error';
                })
        },
        refreshQueue() {
            // Update data
            this.getDequeue();
            this.getQueue();
        }
    },
    created() {
        const that = this;

        // Retrieve database
        this.getCounsellors();
        this.refreshQueue();

        // Auto refresh
        this.dataRefresh = setInterval(function () {
            that.refreshQueue();
        }, 20000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.dataRefresh);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.dataRefresh);
    }
}
</script>

<style scoped>
.ado-admin__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.ado-admin__header-title {
    font-weight: 600;
    margin: 0;
}
</style>